import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="bg-white py-20 px-6" data-id="element-139">
      <div className="max-w-4xl mx-auto" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6" data-id="element-142">
            No es un berrinche. Es un incendio en su sistema nervioso.
          </h2>
          <div className="w-24 h-1 bg-copper mx-auto rounded-full" data-id="element-143"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-144">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-145">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-146">
              Para un niño con autismo, un colapso sensorial no es un berrinche
              por un juguete. Su cerebro ha entrado en modo de supervivencia
              ("lucha o huida") y nada de lo que digas lógicamente va a
              funcionar.
            </p>
            <div className="bg-cream p-6 rounded-xl border-l-4 border-copper" data-id="element-147">
              <p className="text-navy font-medium leading-relaxed" data-id="element-148">
                Vivir en los Estados Unidos añade una presión extra: el miedo a
                que llamen a las autoridades por "falta de control", el juicio
                de quienes no entienden el autismo nivel 1 o 2, y la soledad de
                no tener a tu familia cerca para ayudarte en ese momento de
                caos.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="relative" data-id="element-149">
            <div className="aspect-square bg-teal/10 rounded-full absolute -top-4 -right-4 w-full h-full -z-10" data-id="element-150"></div>
            <img src="https://images.unsplash.com/photo-1544126592-807ade215a0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Madre consolando a su hijo" className="rounded-2xl shadow-lg object-cover w-full h-[400px]" data-id="element-151" />
          </motion.div>
        </div>
      </div>
    </section>;
}